"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const zustandStore_1 = require("../../../../../zustandStore");
const approvalHelpers_1 = require("../../approvalHelpers");
const createCardButton_1 = require("./createCardButton");
const lexico = new lexico_1.default();
const ForwardRequestButton = ({ approvalItem }) => {
    const { setOpenForwardRequestAside, setCurrentApproverItem } = (0, zustandStore_1.useZustand)();
    const { featureAccess, state, outcome } = approvalItem || {};
    const isActivityOrConversationPage = globalThis.location.pathname.includes('activity') || globalThis.location.pathname.includes('approval');
    const isActionable = state === 'ASSIGNED' && !(0, approvalHelpers_1.isProcessing)(approvalItem);
    const { approvals } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const activeHeaderTab = (0, zustandStore_1.useZustand)(state => state.header.activeHeaderTab);
    const { showCreateFwdButtons, isForwardRequestButtonDisabled } = approvals;
    const openForwardRequestAsideFunc = () => {
        setOpenForwardRequestAside(true);
        setCurrentApproverItem(approvalItem);
    };
    const showBtnCondition = outcome !== 'REASSIGNED' && !createCardButton_1.hideBtnOutcomes.includes(outcome) && isActionable;
    const showBtn = (showCreateFwdButtons &&
        activeHeaderTab === 'pending' &&
        isActivityOrConversationPage &&
        featureAccess?.reassignRequest &&
        showBtnCondition) ||
        (isActivityOrConversationPage &&
            approvalItem.currentUserIsNotAssigneerByUserId &&
            (activeHeaderTab === 'pending' || approvalItem.isPending));
    return (showBtn && ((0, jsx_runtime_1.jsx)(material_1.Button, { name: "forawrdRequest", variant: "contained", style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? { textTransform: 'uppercase' } : {}),
        }, disabled: isForwardRequestButtonDisabled, color: "secondary", onClick: openForwardRequestAsideFunc, children: lexico.trc('Button', 'Forward request') })));
};
exports.default = ForwardRequestButton;
